/* eslint-disable react/no-danger */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import { Alert } from '@bingads-webui-react/alert';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { withCustomValidation } from '@bingads-webui-react/validation';
import { ActivityContext } from '@bingads-webui-react/hoc-with-signal';
import { HelpPopup } from '@bingads-webui-react/help-popup';
import { withVerticalAlignCenterSpan } from '@bingads-webui-campaign-react/wizard-shared-components';
import { Checkbox } from '@bingads-webui-react/fabric-control';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { LearnMoreLink } from '@bingads-webui-campaign-react/help';
import { getCPSStyles } from './style';


const CostPerSale = ({ validationProps, updateValidation }) => {
  const activity = useContext(ActivityContext);
  const i18n = useContext(I18nContext);
  const { data: costPerSaleOptOut } = validationProps;
  const onChange = useCallback((newData) => {
    updateValidation([], newData);
    if (activity) {
      activity.signal(`onCPSOptionChange - ${JSON.stringify(newData)}`);
    }
  }, [updateValidation]);

  const classes = useDefaultStyles(getCPSStyles);

  return (
    <div className={classes.cpsOptions}>
      <Checkbox
        className="cost-per-sale-checkbox"
        label={i18n.getString(_TL_('Enable CPS for this campaign'))}
        checked={!costPerSaleOptOut}
        onChange={(_ev, isChecked) => onChange({ costPerSaleOptOut: !isChecked })}
        onRenderLabel={withVerticalAlignCenterSpan(() => (<HelpPopup
          topic="pop_BA_PMAX_CPS"
          aria-label={i18n.getString(_TL_('Click to learn more about Cost per sale'))}
        />))}
      />
      {costPerSaleOptOut &&
        <div className="alert-container">
          <Alert
            message={(
              <LearnMoreLink
                text={(
                  <span dangerouslySetInnerHTML={{ __html: i18n.getString(_TL_('<b>For the best results</b>, consider turning on CPS bid option.')) }} />
                )}
                linkText={i18n.getString(_TL_('Learn more'))}
                href="https://help.ads.microsoft.com/#apex/ads/en/56786/1/#CPS"
                linkType="directLink"
              />
            )}
            level="Info"
            icon={(<div className="alert-image" />)}
            dismissible={false}
          />
        </div>}
    </div>
  );
};

CostPerSale.propTypes = {
  validationProps: PropTypes.shape({
    data: PropTypes.shape({
      costPerSaleOptOut: PropTypes.bool,
    }),
  }).isRequired,
  updateValidation: PropTypes.func.isRequired,
};

export const ValidatedCostPerSale = withCustomValidation(CostPerSale);
